import { createSlice } from '@reduxjs/toolkit';
import { fetchYear } from '../action/yearAction';
const initialState = {
    years: [],
    isLoaderYear: false
};
export const yearSlice = createSlice({
    initialState,
    name: 'year',
    reducers: {},
    extraReducers: {
        [fetchYear.fulfilled.type]: (state, action) => {
            state.years = action.payload;
            state.isLoaderYear = false;
        },
        [fetchYear.pending.type]: (state) => {
            state.isLoaderYear = true;
        }
    }
});
export default yearSlice.reducer;
